module.exports = __webpack_public_path__ + "img/39.781869f6.jpg";